import React, { Component } from 'react';
import { BrowserRouter as Router, Route } from "react-router-dom";
//import logo from './logo.svg';
import './App.css';

import Home from './Home';
import About from './About';
import Service from './Service';
import Info from './Info';
import Contact from './containers/contact/Contact';
import Admin from './admin/Admin';

import { Navbar, Nav, NavItem, Image } from 'react-bootstrap';

class App extends Component {
  render() {
    return (
	  <Router>
	    <div className="App">
	      <Navbar collapseOnSelect>
		    <Navbar.Header>
		      <Navbar.Brand>
	            <Image src="/logo.png" responsive />
		      </Navbar.Brand>
		      <Navbar.Toggle />
		    </Navbar.Header>
		    <Navbar.Collapse>
		      <Nav>
		        <NavItem eventKey={1} href="/">Inicio</NavItem>
		        <NavItem eventKey={2} href="/about">Quiénes somos</NavItem>
		        <NavItem eventKey={3} href="/services">Servicios</NavItem>
		        <NavItem eventKey={4} href="/info">Información</NavItem>
		      </Nav>
		      <Nav pullRight>
		        <NavItem eventKey={1} href="/contact">Contacto</NavItem>
		      </Nav>
		    </Navbar.Collapse>
		  </Navbar>

	      <hr />

	      <Route exact path="/" component={Home} />
	      <Route path="/about" component={About} />
	      <Route path="/services" component={Service} />
	      <Route path="/info" component={Info} />
	      <Route path="/contact" component={Contact} />
	      <Route path="/admin-dm" component={Admin} />

	      <Navbar fixedBottom>
          <Navbar.Text className="footer">
  	          Sitio desarrollado por <Navbar.Link href="http://www.neokode.cl">Neokode</Navbar.Link>
  	        </Navbar.Text>
	      </Navbar>

	    </div>
      </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js